<template>
  <div class="registration-form">
    <div
      v-if="localShowModal"
      class="registration-form__overlay"
    >
      <template v-if="isLoading">
        <modal-loading
          :show="isLoading"
          @close="closeModal"
        ></modal-loading>
      </template>
      <template v-else>
        <component
          :is="componentName"
          :tur="tur"

          @close="closeModal"
          @cancel="closeModal"
          @send-booking="sendBooking"
          @ok="closeModal"
        ></component>
      </template>
    </div>
  </div>
</template>

<script>
	import axios from 'axios';

	import modal from './Modal';
	import modalLoading from './Modal/Loading';
	import modalForm from './Modal/Form';
	import modalSuccess from './Modal/Success';
	import modalError from './Modal/Error';

	export default {
		name: 'RegistrationForm',
		props: {
			showModal: {
				type: Boolean,
				default: false
			},
			id: {
				type: Number,
				default: 0
			},
			isIndividual: {
				type: Number,
				default: 1
			},
			dateStart: {
				type: String,
				default: ''
			},
			dateEnd: {
				type: String,
				default: ''
			}
		},
		components: {
			modal,
			modalLoading,
			modalForm,
			modalSuccess,
			modalError
		},
		data() {
			return {
				turID: 0,
				tur: {},

				localShowModal: false,
				isLoading: false,

				componentName: 'modal-form',

				axiosHeader: {
					headers: {'X-Requested-With': 'XMLHttpRequest'},
					responseType: 'json',
				}
			}
		},
		methods: {
			get() {
				const formData = new FormData();
				formData.append('tur_id', this.turID);

				this.isLoading = true;

				axios.post("/tur/get_info/", formData, this.axiosHeader)
					.then(response => {
						let data = response.data;

						if (response.status === 200 && data.state) {

							this.tur = data.response;
							this.tur.managers_list = this.managers;
							this.tur.turDateStart = this.dateStart;
							this.tur.turDateEnd = this.dateEnd;
							this.isLoading = false;
							this.componentName = 'modal-form';
						}
					})
					.catch(error => {
						this.isLoading = false;
						this.componentName = 'modal-error';
					});
			},

      sendYaCounters() {
				for (let counterName in window.globals.yaCounters) {
					let _ya_counter = window[window.globals.yaCounters[counterName]];
					_ya_counter.reachGoal(this.umt);
        }
      },

			sendBooking(turFormData) {
				this.isLoading = true;

				const formData = new FormData();
				const tur = JSON.stringify(turFormData);

				formData.append('tur', tur);

				this.isLoading = true;

        this.sendYaCounters();

				axios.post("/tur/send_booking/", formData, this.axiosHeader)
					.then(response => {

						let data = response.data;

						this.isLoading = false;

						this.componentName = (response.status === 200 && data.state ? 'modal-success' : 'modal-error');
					})
					.catch(error => {
						this.isLoading = false;
						this.componentName = 'modal-error';
					});
			},

			closeModal() {
				this.localShowModal = false;
				this.tur = {};
				this.$emit('close', this.localShowModal)
			}
		},
		computed: {
			managers() {
				let mList = [];

				if (Object.keys(this.tur).length > 0) {

					mList = this.tur.managers_list.reduce((acc, item) => {

						if (acc.length === 0) {
							acc.push(item);
						} else {
							const hasManager = acc.filter(manager => item.email === manager.email);

							if (!hasManager) {
								acc.push(item);
							}
						}

						return acc;
					}, []);

				}

				return mList;
			},
      umt() {
				return (this.isIndividual ? 't' : 'a') + '_tour_book_organized_groups';
      }
		},
		watch: {
			showModal() {
				this.localShowModal = this.showModal;

				if (this.showModal) {
					// запрос на получения тура
					this.get();
				}
			}
		},
		mounted() {
			this.localShowModal = this.showModal;
			this.turID = this.id;
			this.yaCounters = {...window.globals.yaCounters};
		}
	}
</script>

<style lang="scss">
  .registration-form {

    &__overlay {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .5);
      display: table;
      transition: opacity .3s ease;
    }
  }
</style>



// WEBPACK FOOTER //
// src/Components/RegistrationForm.vue